/* ============================================================================
 * custom.mobile-menu-fallback.js
 * ----------------------------------------------------------------------------
 * TEMPORARY WORKAROUND — remove this file once Buddha Mega Menu properly
 * populates the mobile drawer on its own.
 * ========================================================================= */
(function () {
  if (window.__mobileMenuFallbackInit) return;
  window.__mobileMenuFallbackInit = true;

  function findDesktopMenu() {
    return document.querySelector('.site-navigation .navmenu.navmenu-depth-1');
  }

  function findMobileContainer() {
    var mobileNavContent = document.querySelector('[data-mobile-nav-content]');
    if (!mobileNavContent) return null;
    return mobileNavContent.querySelector('ul.navmenu.navmenu-depth-1');
  }

  function isEmpty(el) {
    return el && el.children.length === 0;
  }

  function cloneMenu() {
    var desktopMenu = findDesktopMenu();
    var mobileContainer = findMobileContainer();

    if (!desktopMenu || !mobileContainer) return false;
    if (desktopMenu.children.length === 0) return false;
    if (!isEmpty(mobileContainer)) return true;

    var clone = desktopMenu.cloneNode(true);
    clone.classList.remove('horizontal-mega-menu');

    while (clone.firstChild) {
      mobileContainer.appendChild(clone.firstChild);
    }

    console.info('[mobile-menu-fallback] Cloned desktop menu into mobile drawer.');
    return true;
  }

  function init() {
    if (cloneMenu()) return;

    var attempts = 0;
    var maxAttempts = 40;
    var interval = setInterval(function () {
      attempts++;
      if (cloneMenu() || attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();